import { consoleApiSlice } from "./consoleApiSlice";

// ---------------------------------------------------------------------------
// Eval Results — read-only visualizer over the process-improvement eval
// store (DynamoDB zenyt-{env}-eval-runs / -eval-cells / -eval-guardrails,
// surfaced by the console backend under /eval-results).
// ---------------------------------------------------------------------------
export const evalResultsApiSlice = consoleApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getEvalRuns: builder.query({
      query: ({ websiteId, agentType, brand, runKind, packVersion, limit = 100 } = {}) => ({
        url: "/eval-results/runs",
        params: {
          ...(websiteId ? { website_id: websiteId } : {}),
          ...(agentType ? { agent_type: agentType } : {}),
          ...(brand ? { brand } : {}),
          ...(runKind ? { run_kind: runKind } : {}),
          ...(packVersion ? { pack_version: packVersion } : {}),
          limit,
        },
      }),
      providesTags: ["EvalRuns"],
    }),

    getEvalFilterOptions: builder.query({
      query: () => "/eval-results/filter-options",
      providesTags: ["EvalFilterOptions"],
    }),

    getEvalRunDetail: builder.query({
      query: (runId) => `/eval-results/runs/${encodeURIComponent(runId)}`,
      providesTags: (result, error, runId) => [{ type: "EvalRunDetail", id: runId }],
    }),

    getEvalTimeline: builder.query({
      query: ({ websiteId, agentType, runKind, limit = 200 }) => ({
        url: "/eval-results/timeline",
        params: {
          website_id: websiteId,
          agent_type: agentType,
          ...(runKind ? { run_kind: runKind } : {}),
          limit,
        },
      }),
      providesTags: (result, error, { websiteId, agentType }) => [
        { type: "EvalTimeline", id: `${websiteId}#${agentType}` },
      ],
    }),

    getEvalGuardrails: builder.query({
      query: ({ agentType, websiteId, guardrailId, limit = 50 } = {}) => ({
        url: "/eval-results/guardrails",
        params: {
          ...(agentType ? { agent_type: agentType } : {}),
          ...(websiteId ? { website_id: websiteId } : {}),
          ...(guardrailId ? { guardrail_id: guardrailId } : {}),
          limit,
        },
      }),
      providesTags: ["EvalGuardrails"],
    }),
  }),
});

export const {
  useGetEvalRunsQuery,
  useGetEvalFilterOptionsQuery,
  useGetEvalRunDetailQuery,
  useGetEvalTimelineQuery,
  useGetEvalGuardrailsQuery,
} = evalResultsApiSlice;
